<template>
  <div>
    <h1>ECommerce Mockup - Browse Products and Add Product to Cart</h1>
    <div id="app">
      <div>
        <div class="catalog" v-for="product in products" :key="product.id">
          <div>
            <img :src="product.photo" width="200" />
          </div>
          <h4>{{ product.productName }}</h4>
          <h6>{{ formatMoney(product.price) }}</h6>
          <h5>
            <button class="AddToCart" @click="increase(product)">
              Add To Cart
            </button>
          </h5>
        </div>
      </div>

      <div class="text-right">
        <button
          class="btn btn-primary"
          data-toggle="modal"
          data-target="#cartModal"
        >
          Cart ({{ carts.length }})
        </button>
      </div>

      <table class="table" v-if="carts.length > 0">
        <thead>
          <tr>
            <td>Product Name</td>
            <td>Price</td>
            <td>Quantity</td>
            <td>Total</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(cart, index) in carts" :key="cart.id">
            <td>{{ cart.productName }}</td>
            <td>{{ formatMoney(cart.price) }}</td>
            <td>
              <i
                class="link fa fa-plus"
                aria-hidden="true"
                @click="increase(cart)"
              ></i>
              {{ cart.quantity }}
              <i
                class="link fa fa-minus"
                aria-hidden="true"
                @click="decrease(cart)"
              ></i>
            </td>
            <td>{{ formatMoney(cart.total) }}</td>
            <td>
              <button @click="removeItem(index)">
                <font-awesome-icon icon="spinner" />
              </button>
            </td>
          </tr>
          <tr>
            <td>
              Total
            </td>
            <td>{{ formatMoney(Total) }}</td>
            <td colspan="3" class="clearCart">
              <a @click="clearCart">Clear cart</a>
            </td>
          </tr>
        </tbody>
      </table>

      <p v-else>No items in the cart.</p>
    </div>
  </div>
</template>

<script>
function cart(product) {
  this.id = product.id;
  this.productName = product.productName;
  this.price = product.price;
  this.quantity = 1;
  this.total = product.price;
}

const findProduct = (carts, itemId) => {
  const foundIndex = carts.findIndex(prod => prod.id == itemId);
  return foundIndex;
};

const productData = [
  {
    id: 1,
    productName: "iPhone",
    price: 4400,
    photo: "https://clipart.info/images/ccovers/1505918647iphone-x-png.png"
  },
  {
    id: 2,
    productName: "Samsung",
    price: 3000,
    photo: "https://clipart.info/images/ccovers/1505918647iphone-x-png.png"
  },
  {
    id: 3,
    productName: "Huawei",
    price: 3600,
    photo: "https://clipart.info/images/ccovers/1505918647iphone-x-png.png"
  }
];

// const cartData = [
//   { id: 2, productName: "Samsung", price: 3000, quantity: 2, total: 0 },
//   { id: 3, productName: "iPhone", price: 4500, quantity: 1, total: 0 }
// ];

const cartData = [];

export default {
  data: function() {
    return {
      products: productData,
      carts: cartData
    };
  },
  methods: {
    increase(itemToAdd) {
      const foundIndex = findProduct(this.carts, itemToAdd.id);

      if (foundIndex === -1) {
        this.carts.push(new cart(itemToAdd, 1));
      } else {
        this.carts[foundIndex].quantity++;

        this.carts[foundIndex].total =
          this.carts[foundIndex].quantity * this.carts[foundIndex].price;
      }
    },
    decrease(itemToAdd) {
      const foundIndex = findProduct(this.carts, itemToAdd.id);

      if (foundIndex !== -1) {
        if (this.carts[foundIndex].quantity > 1)
          this.carts[foundIndex].quantity--;
      }

      this.carts[foundIndex].total =
        this.carts[foundIndex].quantity * this.carts[foundIndex].price;
    },
    removeItem(index) {
      this.carts.splice(index, 1);
    },
    clearCart() {
      this.carts = [];
    },
    formatMoney(number) {
      return number.toLocaleString("en-US", {
        style: "currency",
        currency: "MYR"
      });
    }
  },
  computed: {
    Total() {
      //       let total = 0;

      //       // can be replaced with 'reduce'
      //       this.carts.forEach(item => {
      //         total += (item.price * item.quantity);
      //       });
      //       return total;

      return this.carts.map(li => li.total).reduce((sum, val) => sum + val, 0);
    }
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Open+Sans:300,400,700");
*,
*::before,
*::after {
  box-sizing: border-box;
}
body {
  font-family: "Open Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  padding: 3rem;
  display: flex;
  justify-content: center;
}
div.catalog {
  margin: 5px;
  border: 1px solid silver;
  display: inline-block;
  padding: 10px;
  text-align: center;
}
i.link {
  cursor: pointer;
}
td.clearCart {
  color: red;
  text-align: right;
  cursor: pointer;
}
button.AddToCart {
  padding: 0.35rem 0.7rem 0.28rem;
  border: 0;
  text-transform: uppercase;
  font-size: 0.85em;
  color: #fff;
  background: rgba(0, 0, 0, 0.5);
  box-shadow: 0 18px 10px -10px rgba(0, 0, 0, 0.25);
  transition: background 0.4s, box-shadow 0.4s;
  cursor: pointer;
  outline: none;
}
button.AddToCart:hover,
button.AddToCart:focus {
  background: #000;
  box-shadow: 0 18px 10px -10px rgba(0, 0, 0, 0);
}
</style>
